import './SidePanel.scss'
import React from 'react'

import { placeHolderText } from 'utils/Content';
import {
  bool,
  string
} from 'prop-types';
import Accordion from 'components/shared/Accordion/Accordion';

const SidePanel = ({ enable, title, contentFragments, currentStep }) => {
  if (enable && contentFragments && contentFragments.length){
    return(
        <div className="sidebar">
          <div tabIndex="0"
               className="sidebar-title">{title}</div>
          <div className="sidebar-content">
            {contentFragments.map((fragment, i) =>
              <Accordion key={`content-fragment-step-${currentStep}-${i}`}
                         title={fragment.question.value}
                         titleContentType={fragment.question[':type']}
                         body={fragment.answer.value}
                         bodyContentType={fragment.answer[':type']}/>
            )}
          </div>

        </div>
    )
  }
  return null
}

SidePanel.propTypes = {
  content: string,
  title: string,
  enable: bool.isRequired
}

SidePanel.defaultProps = {
  content: placeHolderText,
  title: 'Commonly Asked Questions',
  enable: false,
}

export default SidePanel;